<style lang="less" scoped>
  #login {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #fafafa;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container {
    width: 360px;
    border: solid .5px #d9dde8;
    border-radius: 2px;
    background-color: #fff;
    align-items: center;
    padding: 54px 16px 16px 16px;

    .logo {
      text-align: center;
      margin-bottom: 44px;
    }

    .login-form {
      margin-bottom: 16px;

      .form__input {
        margin-bottom: 16px;
      }
      .form__btn {
        width: 100%;
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 560px) {
    #login {
      background: white;
    }

    .container {
      width: 100%;
      border: none;
    }
  }
</style>

<template lang="pug">
  #login
    .container
      .logo
        img(src="@/assets/logo.png")
      form.login-form(@submit.prevent="login")
        el-input.form__input(type="text", v-model="email", placeholder="아이디")
        el-input.form__input(type="password", v-model="password", placeholder="비밀번호")
        el-button.form__btn(type="success", native-type="submit") 로그인
</template>

<script>
export default {
  data() {
    return {
      email: null,
      password: null,
    };
  },
  methods: {
    async login() {
      try {
        const { data } = await this.$http.post('/login', {
          email: this.email,
          password: this.password,
        });
        this.$localStorage.set('admin-token', data.token);
        this.$http.defaults.headers.common.Authorization = `Bearer ${data.token}`;
        this.$router.push('/admin');
      } catch (e) {
        const msg = e.response.data.message;
        alert(`${msg}`);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/login.vue